import crypto from "crypto";
import axios from "axios";

export const useNumberFormatter = (number) => {
  return new Intl.NumberFormat().format(number);
};

// Generate encryption key and IV
export const generateKeyAndIV = (secret, length) => {
  const hash = crypto.createHash("sha256").update(secret).digest("hex");
  return hash.substring(0, length);
};

// Decrypt Data

export const decryptData = (encryptedData, key, iv) => {
  try {
    const buff = Buffer.from(encryptedData, "base64");
    const utfData = buff.toString("utf8");

    const decipher = crypto.createDecipheriv(
      process.env.VUE_APP_ECNRYPTION_METHOD_LOGIN,
      key,
      iv
    );
    let decrypted =
      decipher.update(utfData, "hex", "utf8") + decipher.final("utf8");
    decrypted = decrypted.trim();

    return decrypted;
  } catch (error) {
    console.log({ error });
  }
};

/**
 * Download a file from a given URL
 * @param {string} url - The URL or API endpoint of the file
 * @param {string} filename - The name of the file to save as (default: "file.xlsx")
 */
export const downloadFile = async (url, filename = "file.xlsx") => {
  try {
    if (url.startsWith("http")) {
      // For public links
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename || "promotion.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      return;
    }

    // For protected API endpoints
    const response = await axios.get(url, {
      responseType: "blob",
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });

    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error("Download failed:", err);
  }
};
